import { useEffect, useState } from "react"

const useIsSmallScreen = () => {
  const [isSmall, setIsSmall] = useState(false)

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 639px)")
    setIsSmall(mq.matches)
    const handler = (e: MediaQueryListEvent) => setIsSmall(e.matches)
    mq.addEventListener("change", handler)
    return () => mq.removeEventListener("change", handler)
  }, [])

  return isSmall
}

export default useIsSmallScreen
